import { ApiService } from './api/api'
import type { AxiosResponse } from 'axios'

export default class StockTakeService {
  private apiService

  constructor() {
    this.apiService = new ApiService()
  }

  /**
   * Get all depots
   */
  getDepots(): Promise<AxiosResponse> {
    return this.apiService.get(`/depots`)
  }

  /**
   * Get stock take items for a depot
   * @param depot Depot code e.g. DEW
   * @param filters search, subGroup, area
   */
  getStockitems(depot: string, search: string): Promise<any> {
    return this.apiService.get(`/depots/${depot}/stock-take?${search}`)
  }

  addStockItem(depot: string, data: object): Promise<any> {
    return this.apiService.post(`/depots/${depot}/stock-take`, data)
  }

  updateStockItem(depot: string, id: string, data: object): Promise<AxiosResponse> {
    return this.apiService.patch(`/depots/${depot}/stock-take/${id}`, data)
  }

  getStockImport(): Promise<AxiosResponse> {
    return this.apiService.get(`/stock-take-import`)
  }

  getStockExport(): Promise<AxiosResponse> {
	  return this.apiService.get(`/stock-take-export`)
  }

  importStockItems(depotprefix: string,type: string): Promise<AxiosResponse> {
    return this.apiService.post(`/stock-take-import`, { depot: depotprefix, type: type })
  }

  exportStockItems(depotprefix: string): Promise<AxiosResponse> {
    return this.apiService.post(`/stock-take-export`, { depot: depotprefix})
  }
}
